import { SheetFooter } from "src/components/shadcn";
import { PropertyFiltersProps } from "../components/PropertyFilters";
import { SearchSidebar, SearchSidebarTabs } from "./SearchSidebar";
import {
  ListSearchesSidebar,
  ListSearchesSidebarProps,
} from "./ListSearchesSidebar";
import {
  RegionSearchResults,
  RegionSearchResultsProps,
} from "./SearchSidebar/RegionSearchResults";
import { ListSearchesSidebarFooter } from "./ListSearchesSidebar/ListSearchesSidebarFooter";
import {
  AddressSearchResults,
  AddressSearchResultsProps,
} from "./SearchSidebar/AddressSearchResults";

export enum SidebarTabs {
  Search = "search",
  List = "list",
}

interface SidebarProps {
  activeTab: SidebarTabs;
  activeNewSearchTab: SearchSidebarTabs | undefined;
  onLoadSearchesClick: () => void;
  RegionSearchResultsProps: RegionSearchResultsProps;
  AddressSearchResultsProps: AddressSearchResultsProps;
  ListSearchesSidebarProps: ListSearchesSidebarProps;
  PropertyFiltersProps: PropertyFiltersProps;
  hasSearchResults: boolean;
}

const Sidebar = ({
  activeTab,
  activeNewSearchTab,
  PropertyFiltersProps,
  AddressSearchResultsProps,
  ListSearchesSidebarProps,
  RegionSearchResultsProps,
  onLoadSearchesClick,
  hasSearchResults,
}: SidebarProps) => {
  return (
    <div className="w-full h-full flex flex-col">
      <div className="flex-1 overflow-y-auto">
        {activeTab === SidebarTabs.Search && (
          <SearchSidebar PropertyFiltersProps={PropertyFiltersProps} />
        )}
        {activeTab === SidebarTabs.List && (
          <ListSearchesSidebar {...ListSearchesSidebarProps} />
        )}
      </div>
      {activeTab === SidebarTabs.List && (
        <SheetFooter>
          <ListSearchesSidebarFooter
            onLoadSearchesClick={onLoadSearchesClick}
            selectedSearches={ListSearchesSidebarProps.selectedSearches}
          />
        </SheetFooter>
      )}
      {activeTab === SidebarTabs.Search && hasSearchResults && (
        <SheetFooter>
          {activeNewSearchTab === SearchSidebarTabs.RegionSearchResults ? (
            <RegionSearchResults {...RegionSearchResultsProps} />
          ) : (
            <AddressSearchResults
              {...AddressSearchResultsProps}
              key={AddressSearchResultsProps.searchQueryAddress}
            />
          )}
        </SheetFooter>
      )}
    </div>
  );
};

export default Sidebar;
